module.exports = __webpack_public_path__ + "img/Mask Group_1@2x.14e10bac.png";